export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_verify_email-39f258d98a1b170708d2576a46a9f976.svg";